module.exports = __webpack_public_path__ + "h5/img/master_1.5a24f44b.jpg";